/**
 * LazyLoading & Intersection Observer
 */

import lozad from 'lozad';

// Images
export function lazyLoadObserve() {
  const simpleLazyImgs = document.querySelectorAll('.lazy-image img');
  const observer = lozad(simpleLazyImgs, {
    threshold: 0.1,
    load: function(el) {
      el.src = el.getAttribute('data-src');
      el.srcset = el.getAttribute('data-srcset');
    },
    loaded: function(el) {
      el.removeAttribute('data-src');
      el.removeAttribute('data-srcset');
      el.onload = function() {
        this.parentNode.setAttribute('data-fully-loaded', true);
      };
    }
  });
  return observer;
}

const defaultObserver = lazyLoadObserve();
defaultObserver.observe();
